var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedConfIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.088,
    height: 132.597,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SpeedConfIconYellow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 286",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h76v76H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SpeedConfIconYellow_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 287",
    fill: "none",
    d: "M0 0h76v76H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 533"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.995 41.531)",
    clipPath: "url(#SpeedConfIconYellow_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ArmPower"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 313",
    fill: "#040000",
    clipPath: "url(#SpeedConfIconYellow_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 329",
    d: "M38.028 8.178a18.8 18.8 0 00-19 18.591c0 6.7 3 13.5 8.656 16.329h20.688c5.66-2.829 8.656-9.629 8.656-16.329a18.8 18.8 0 00-19-18.591m0 30.2a11.979 11.979 0 1111.978-11.975 11.979 11.979 0 01-11.978 11.979m0-22.607a10.628 10.628 0 1010.627 10.628 10.628 10.628 0 00-10.627-10.628"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 330",
    d: "M58.277 61.758l11.258-17.19-15.4-10.426 2.716-4.559 18.152 12.561a2.312 2.312 0 01.586 3.214l-.024.035-15.296 18.96-10.97 3.443a.578.578 0 01-.443-1.062z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 331",
    d: "M17.723 61.758L6.465 44.568l15.4-10.426-2.716-4.559L1 42.144a2.312 2.312 0 00-.589 3.214l.024.035 15.3 18.957L26.7 67.796a.578.578 0 00.443-1.062z"
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 2",
    d: "M70.743 92.246h-7.27v27.93h7.27l-11.748 11.715-11.746-11.715h7.123v-27.93h-7.123l11.748-11.715z",
    fill: "#00b050",
    stroke: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 531"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "2Arrows"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Arrow2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "arrow.image"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 3",
    d: "M49.41 13.71l-4.124 4.125 29.491 29.49 4.125-4.124 5.706 19.034-19.035-5.706 4.042-4.042-29.49-29.49-4.042 4.042-5.71-19.04z",
    fill: "#ffc000",
    stroke: "#4d4d4d"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Arrow2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "arrow.image"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 2",
    d: "M27.525 25.6v5.681h62.038V25.6l26.022 9.18-26.022 9.178v-5.566H27.525v5.566l-26.022-9.18z",
    fill: "#ffc000",
    stroke: "#4d4d4d"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedConfIconYellow);
export default __webpack_public_path__ + "static/media/SpeedConfIconYellow.812c2fe0bb91f44f.svg";
export { ForwardRef as ReactComponent };